//
import notEmpty from "./notEmpty"

/**
 * 
 */
export default function (val) {
    return notEmpty(val) || "Este campo es obligatorio."
}
